import { Accordion } from '@base-ui/react/accordion';
import styled from 'styled-components';
import { themeGet } from 'modules/tetrisTheme';
export const Content = styled(Accordion.Panel) `
  overflow: hidden;
  height: var(--accordion-panel-height);
  transition: height 300ms ease-out;

  &[data-starting-style],
  &[data-ending-style] {
    height: 0;
  }
`;
export const ContentSpacer = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${themeGet('spacing.lg')};
  padding-top: ${themeGet('spacing.xl')};
`;
